import React from 'react'
import SectionTitle from '../../components/section_title/section_title'
import './service.scss'

import card01 from '../../assets/card_a.png'
import card02 from '../../assets/card_b.png'
import card03 from '../../assets/card_c.png'

function Service() {
  return <div className="service_container">
    <SectionTitle type="black" subtitle="全面降低3D数字建模门槛,快速批量上线">配套自主研发光场复现建模服务</SectionTitle>
    <div className="show_cards">
      <img src={card01}></img>
      <img src={card02}></img>
      <img src={card03}></img>
    </div>
  </div>
}

export default Service